import type { BlockDefinition } from '../types';
import { heroSplitSchema, type HeroSplitData } from './schema';
import { HeroSplitRenderer } from './Renderer';

export const heroSplitBlock: BlockDefinition<HeroSplitData> = {
  meta: {
    type: 'hero-split',
    label: 'Hero split (texto + imagen)',
    description: 'Hero a dos columnas: texto a un lado, imagen al otro. Tema configurable.',
    category: 'hero',
    icon: 'columns-2',
  },
  schema: heroSplitSchema,
  defaults: {
    eyebrow: 'Comprar empresa',
    h1: 'Encuentra la empresa',
    highlight: 'que estás buscando',
    sub: 'Acceso a operaciones off-market y filtros avanzados por sector, ubicación y facturación.',
    ctaPrimary: { label: 'Ver empresas en venta', href: '/empresas-en-venta' },
    ctaSecondary: { label: 'Hablar con un asesor', href: '/contacto' },
    image: '/assets/hero-split-placeholder.jpg',
    imageAlt: 'Sala de reuniones de un M&A',
    reverse: false,
    theme: 'light',
  },
  fields: [
    { name: 'eyebrow', label: 'Eyebrow', type: 'text', max: 80 },
    { name: 'h1', label: 'Título principal', type: 'text', required: true, max: 200 },
    { name: 'highlight', label: 'Texto destacado', type: 'text', max: 60 },
    { name: 'sub', label: 'Subtítulo', type: 'textarea', max: 400 },
    {
      name: 'ctaPrimary',
      label: 'CTA primario',
      type: 'object',
      fields: [
        { name: 'label', label: 'Texto', type: 'text' },
        { name: 'href', label: 'URL', type: 'url' },
      ],
    },
    {
      name: 'ctaSecondary',
      label: 'CTA secundario',
      type: 'object',
      fields: [
        { name: 'label', label: 'Texto', type: 'text' },
        { name: 'href', label: 'URL', type: 'url' },
      ],
    },
    { name: 'image', label: 'Imagen', type: 'image', required: true },
    { name: 'imageAlt', label: 'Texto alternativo', type: 'text', max: 160 },
    { name: 'reverse', label: 'Invertir lado de imagen', type: 'boolean' },
    {
      name: 'theme',
      label: 'Tema',
      type: 'select',
      options: [
        { label: 'Claro', value: 'light' },
        { label: 'Oscuro', value: 'dark' },
        { label: 'Lima (acento)', value: 'lime' },
      ],
    },
  ],
  Renderer: HeroSplitRenderer,
};

export { heroSplitSchema, HeroSplitRenderer };
export type { HeroSplitData };
